import { useState } from 'react';

import { SvgPlayTriangleOutlined } from '@/lib/shared/icons/SvgPlayTriangleOutlined';

import { clsx } from 'clsx';

import styles from './VideoModal.module.scss';

import { P1 } from '../Typography';

interface IVideoModal {
  videoId?: string;
  className?: string;
  description?: string;
  onClick?: () => void;
  disablePlayOnClick?: boolean;
}
export const VideoModal = ({
  videoId,
  className,
  description,
  onClick,
  disablePlayOnClick,
}: IVideoModal) => {
  const [isActive, setIsActive] = useState(false);
  const initPlayback = () => {
    if (!disablePlayOnClick) {
      setIsActive(true);
    }
    if (onClick) {
      onClick();
    }
  };
  if (!videoId) return null;
  const videoUrl = 'https://youtube.com/embed/' + videoId;
  return (
    <div
      className={clsx(
        className,
        styles['video__overlay'],
        isActive && styles['video__overlay--active']
      )}
      id={videoId}
      style={{
        backgroundImage: isActive
          ? 'none'
          : `url(https://img.youtube.com/vi/${videoId}/maxresdefault.jpg)`,
      }}
      onClick={() => initPlayback()}
    >
      {/* <Image
        loader={({ src }) => src}
        width={1024}
        height={768}
        sizes="(max-width: 768px) 100vw, (max-width: 1320px) 100vw,(max-width: 1624px) 80vw, 1440px"
        className={clsx(
          styles["video__thumbnail"],
          isActive && styles["video__thumbnail--inactive"],
        )}
        src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
        alt={"обложка"}
      /> */}
      {!isActive && (
        <div className={styles.video__play}>
          <SvgPlayTriangleOutlined />
        </div>
      )}
      {isActive && (
        <iframe
          loading="lazy"
          className={clsx(
            styles['video__iframe'],
            isActive ? styles['video__iframe--active'] : ''
          )}
          src={videoUrl + '?autohide=1&showinfo=0&autoplay=1&mute=1'}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          onClick={() => setIsActive(true)}
        />
      )}
      {description && (
        <P1 className={styles.video__description}>{description}</P1>
      )}
    </div>
  );
};
